import { ShoppingList } from "../Components/Icons";

const obj = {
  title: "Shopping List",
  desc: "Quickly compile a shopping list from various ingredients.",
  category: "Meal Planning",
  Icon: ShoppingList,
  // tags: [],
  permissions: ["user"],

  fromColor: "gray-500",
  toColor: "gray-500",

  to: "/ai/shoppingList",
  api: "/ai/shoppingList",

  output: {
    title: "Shopping List",
    desc: "Concise shopping list compiled from your ingredients",
    // Icon: RefreshIcon,
    // color: "",
},

  video:
    "https://mealpalaivideos.s3.ap-southeast-2.amazonaws.com/Shopping_list.mp4",

    prompts: [{

      title:"Input your ingredients",
      desc: "Copy and paste a list of your ingredients below",
      // n: 1,
      prompts: [
          { 
              title: "Ingredients List", 
              attr: "content",  
              value: "", 
              placeholder: "1 pound of pasta, 1 cup basil pesto, 1 pint of cherry tomatoes, 1/4 cup pine nuts, salt and black pepper and Grated Parmesan cheese", 
              label: "",
              type: "textarea",
              maxLength: 2000,
              // max: 100,
              // min: 1,
              required: true,
              error: "",
              example: "RECIPE INGREDIENTS 1\n2 boneless, skinless chicken breasts\n1 large sweet potato\n1 cup quinoa\n2 tbsp olive oil\n2 tbsp lemon juice\n2 cloves garlic, minced\n2 cups chopped kale\n1/2 cup pomegranate seeds\n1/4 cup crumbled feta cheese\nsalt and pepper to taste\n4 oz mixed greens\n1 avocado\n\nRECIPE INGREDIENTS 2\n1 lb sirloin steak, sliced thin\n3 cups chopped broccoli florets\n1 1/2 cups brown rice\n2 tbsp soy sauce\n2 tbsp hoisin sauce\n1 tbsp grated ginger\n2 cloves garlic, minced\n1 tsp red pepper flakes\n1 tsp sesame oil\n1 tbsp cornstarch\n2 tbsp vegetable oil\n3 green onions, sliced\n1 red bell pepper, sliced\n1 yellow onion, sliced\n\nRECIPE INGREDIENTS 3\n4 salmon fillets\n1 lb asparagus\n1 large head of cauliflower\n3 tbsp olive oil\n2 tbsp lemon juice\n2 cloves garlic, minced\nsalt and pepper to taste\n2 tbsp chopped fresh parsley\n1 cup cherry tomatoes, halved\n1 lemon, sliced",
          },
      ],
      example: {
output: `2 chicken breasts
1 large sweet potato
Quinoa
Olive oil
Lemon juice
6 cloves garlic
Kale
Pomegranate seeds
Feta cheese
Salt
Pepper
Mixed greens
1 avocado
1lb sirloin steak
Broccoli florets
Brown rice
Soy sauce
Hoisin sauce
Ginger
Red pepper flakes
Sesame oil
Cornstarch
Vegetable oil
3 green onions
1 red bell pepper
1 yellow onion
4 salmon fillets
1lb asparagus
1 large head of cauliflower
Fresh parsley
Cherry tomatoes
1 lemon`,
          // outputs: [],
          // Icon: RefreshIcon,
          // color: "",
      }
  }]
      
}

export default obj